import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "AdiYogi Handcrafts — Brass, Bronze, Rudraksha & German Silver Pooja, Décor & Spiritual Gifts",
  description: "Shop premium handcrafted Brass, Bronze, Rudraksha and German Silver pooja items, spiritual gifts, home & temple décor. Prepaid UPI · Pan-India & worldwide shipping.",
  image: "/adiyogi-hero.jpg",
};

export default function SEO({ title, description, image, canonical, schema, noindex }) {
  const t = title ? `${title} | AdiYogi Handcrafts` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content="website" />
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
